// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  display: flex;
  height: 100vh;
  font-family: Arial, sans-serif;
}

/* Sidebar styling */
.sidebar {
  width: 220px;
  background-color: #1f2937; /* dark gray/navy tone */
  color: white;
  padding-top: 1rem;
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar li {
  margin: 0;
}

/*
.sidebar li:first-child {
  margin-top: 40%;
}
*/


.sidebar a {
  display: block;
  padding: 1rem 1.5rem;
  color: #cbd5e1;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.3s, color 0.3s;
}

/* Hover & active states */
.sidebar a:hover {
  background-color: #374151;
  color: #fff;
}

.sidebar a.active {
  background-color: #2563eb; /* blue highlight */
  color: #fff;
}

/* Main content area */
.content {
  flex: 1 1;
  padding: 2rem;
  background-color: #f9fafb;
  overflow-y: auto;
}

.sidebar-header {
  font-weight: bold;
  font-size: 20px;
  padding: 20px 10px 10px 10px; /* top, right, bottom, left */
}

/* 🔹 Logout section */
.logout-item {
  text-align: center;
}

.logout-button {
  background: none;
  border: none;
  color: #777;
  font-size: 0.7em;
  cursor: pointer;
  padding: 0;
}

.logout-button:hover {
  color: #333;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,yBAAyB,EAAE,wBAAwB;EACnD,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;;;;CAIC;;;AAGD;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B,EAAE,6BAA6B;AAC7D;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B","sourcesContent":[".dashboard {\n  display: flex;\n  height: 100vh;\n  font-family: Arial, sans-serif;\n}\n\n/* Sidebar styling */\n.sidebar {\n  width: 220px;\n  background-color: #1f2937; /* dark gray/navy tone */\n  color: white;\n  padding-top: 1rem;\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.sidebar li {\n  margin: 0;\n}\n\n/*\n.sidebar li:first-child {\n  margin-top: 40%;\n}\n*/\n\n\n.sidebar a {\n  display: block;\n  padding: 1rem 1.5rem;\n  color: #cbd5e1;\n  text-decoration: none;\n  font-weight: 500;\n  transition: background 0.3s, color 0.3s;\n}\n\n/* Hover & active states */\n.sidebar a:hover {\n  background-color: #374151;\n  color: #fff;\n}\n\n.sidebar a.active {\n  background-color: #2563eb; /* blue highlight */\n  color: #fff;\n}\n\n/* Main content area */\n.content {\n  flex: 1;\n  padding: 2rem;\n  background-color: #f9fafb;\n  overflow-y: auto;\n}\n\n.sidebar-header {\n  font-weight: bold;\n  font-size: 20px;\n  padding: 20px 10px 10px 10px; /* top, right, bottom, left */\n}\n\n/* 🔹 Logout section */\n.logout-item {\n  text-align: center;\n}\n\n.logout-button {\n  background: none;\n  border: none;\n  color: #777;\n  font-size: 0.7em;\n  cursor: pointer;\n  padding: 0;\n}\n\n.logout-button:hover {\n  color: #333;\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
